import { useMe } from '../users/useMe';

export const useCorporations = () => {
    const res = useMe();
    return { ...res, data: res.data?.corporations };
};
